import List, { ListComponent, ListOptions } from './Classes/List';
import ListItem from './Classes/Item';

export default (options: ListOptions, filterData = {}):ListComponent<ListItem> => (
  List(options, filterData)
);
